import React, { useState, useEffect } from "react";
import axios from "axios";
import { Radio, Table, Input, Typography, Space, Modal, Row, Col, message, Image, Carousel, Button } from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import { ExclamationCircleOutlined, PlusOutlined, CloseCircleOutlined, EditOutlined } from "@ant-design/icons";
import NewsModal from './components/NewsModal';
import NewTable from "./components/NewTable";
import Carousel_news_ticker from "./components/Carousel_news_ticker";
const { Paragraph, Text } = Typography;
const { confirm } = Modal;
const AdminNews = () => {
    const [total, set_total] = useState(1);
    const [extra_columns, set_extra_columns] = useState(null);
    const [datas, setDatas] = useState([]);
    const [loading, set_loading] = useState(0)
    const [force_reload, set_force_reload] = useState(0)
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [title, setTitle] = useState('新增貼文');
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [color, setColor] = useState('FF6B90');
    const [editcard, setEditCard] = useState({});
    const [messageApi, contextHolder] = message.useMessage();
    const [default_column, set_default_column] = useState([
        {
            title: '照片',
            sorter: false,
            align: 'center',
            width: '20%',
            render: (text, record, index) => (
                <div
                    style={{
                        padding: 0,
                        margin: 'auto',
                        width: '150px',
                    }}
                >
                    <Carousel_news_ticker
                        file_url={record['file_url']}
                    />
                </div>
                // <Row gutter={8}>
                //     {/* <Carousel> */}
                //     {record['file_url'] ? record['file_url'].map((tmp, index) => {
                //         return (
                //             <>
                //                 <Col >
                //                     <img width="80px" height="auto" alt="example" src={tmp} />
                //                 </Col >
                //             </>
                //         )
                //     }) :
                //         <>
                //             <Col >
                //                 <img width="80px" height="auto" src="data:image/png;base64,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" />
                //             </Col >

                //         </>}
                //     {/* </Carousel> */}
                //     {/* <img src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png" width={'100 %'}></img> */}
                // </Row >
            ),
            // width: '40%'
        },
        {
            title: '名稱',
            key: 'title',
            dataIndex: 'title',
            align: 'center',
        },
        {
            title: '內文',
            key: 'content',
            width: '20%',
            render: (text, record, index) => (
                <>
                    <Col span={24}>
                        <Paragraph
                            ellipsis={{
                                rows: 3,
                                expandable: true,
                                symbol: 'more',
                            }}
                        >
                            {record['content']}
                        </Paragraph>
                    </Col>
                </>
            )
        },
        {
            title: '最後編輯時間',
            key: 'last_edit_time',
            dataIndex: 'last_edit_time',
            align: 'center'
        },
        {
            title: '操作',
            sorter: false,
            align: 'center',
            render: (text, record, index) => (
                <>
                    <Button type="text" style={{ color: 'rgba(43, 193, 123, 1)' }} onClick={e => handleOnEdit(record)}>編輯</Button>
                    <Button type="text" style={{ color: 'red' }} onClick={(e) => showMessage(record.blog_id)}>刪除</Button>
                </>
            )
        },
    ])
    const handleOnAddRow = () => {
        setTitle('新增貼文');
        setColor('FF6B90');
        setEditCard({});
        setEdit(false);
        setOpen(true)
    }
    const getData = (param, sort, filter, checklist) => {
        set_loading(true);
        return axios
            .get('/cramSchool/api/blog/lastest', {
                params: {
                    cur_page: param?.current,
                    size: param?.pageSize,
                    custom_filter_key: checklist,
                    custom_filter_value: param?.keyword,
                    order: sort && Object.entries(sort).map(([map_key, map_value]) => ({ column: map_key, type: map_value })),
                    blog_type_id: 1
                }
            })
            .then((response) => {
                set_total(response.data.total)
                setDatas(response.data.data);
                get_picture(response.data.data);
            })
            .finally(() => {
                set_loading(false)
            })
    }
    const get_picture = (data_tmp) => {
        // console.log(data_tmp);
        data_tmp && data_tmp.map((value, index) => {
            let blog_id = value['blog_id']
            if (value.file_id.length != 0) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            setDatas(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (blog_id == value.blog_id) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )

                                            }
                                        })
                                    )
                                }
                            )
                        })
                })
            }
        })

    }
    useEffect(() => {
        if (extra_columns === null) {
            get_table_setting();
        } else {
            set_table_setting()
        }
    }, [extra_columns])
    const set_table_setting = () => {
        axios
            .post('/cramSchool/api/custom_table_setting', [
                {
                    table_name: 'news',
                    table_data: [
                        ...extra_columns.map(map_item => ({
                            column_key: map_item.key,
                            column_name: map_item.key
                        }))
                    ]
                }
            ])
    }
    const get_table_setting = () => {
        axios
            .get('/cramSchool/api/custom_table_setting', {
                params: {
                    custom_table_setting_table_name: 'news'
                }
            })
            .then(response => {
                set_extra_columns(response.data.map(map_item => ({
                    title: map_item.column_key,
                    key: map_item.column_key,
                    dataIndex: map_item.column_key,
                })))
            })
    }
    useEffect(() => {
        getData();
    }, []);
    const handleOnEdit = (key) => {
        setTitle('修改貼文');
        setColor('f09a45');
        setEdit(true);
        setEditCard(key);
        setOpen(true)
    }
    const handleEdit = (file_id) => {
        setOpen(false);
        // let data_tmp = [{ ...editcard }];
        if (editcard['file_id'] == "{0}") {
            editcard['file_id'] = null;
        }
        // console.log(editcard); 
        axios
            .patch(`/cramSchool/api/blog/lastest`, [{ ...editcard, file_id, "blog_type_id": 1 }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '修改失敗',
                    });
                    reload();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '修改成功',
                    });
                    reload();
                }
            })
    }
    const handleSubmit = (file_id) => {
        if (JSON.stringify(editcard) == '{}') {
            // setOpen(false);
            messageApi.open({
                type: 'error',
                content: '新增失敗，請填寫任一欄位',
            });
        } else {
            console.log(editcard['annoucement_time']);
            if (editcard['annoucement_time'] == undefined) {
                var Today = new Date();
                editcard['annoucement_time'] = `${Today.getFullYear()}-${Today.getMonth() + 1}-${Today.getDate()}`;
            }
            // console.log(editcard);
            axios
                .post(`/cramSchool/api/blog/lastest`, [{ ...editcard, file_id, "blog_type_id": 1 }])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '新增失敗',
                        });
                        reload();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '新增成功',
                        });
                        reload();
                    }
                })
            // console.log(editcard); 
        }
    }
    const handleOnDeleteRow = () => {
        if (selectedRowKeys.length == 0) {
            messageApi.open({
                type: 'error',
                content: '請選擇資料',
            });
        } else {
            const deleterow = [];
            selectedRowKeys && selectedRowKeys.map((value) => {
                deleterow.push({ 'blog_id': value });
            })
            // console.log(deleterow);
            axios
                .delete('/cramSchool/api/blog/lastest', {
                    data: deleterow
                })
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '刪除失敗',
                        });
                        reload();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '刪除成功',
                        });
                        reload();
                    }
                })
        }
    }
    const showMessage = (value) => {
        confirm({
            title: '確定要刪除嗎',
            icon: <ExclamationCircleOutlined />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                handleDelete(value);
            },
            centered: true
        });
    };
    const handleDelete = (value) => {
        axios
            .delete('/cramSchool/api/blog/lastest', {
                blog_id: value
            })
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '刪除失敗',
                    });
                    reload();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '刪除成功',
                    });
                    reload();
                }
            })

    }
    const reload = () => {
        set_force_reload(prev => prev + 1)
    }
    return (
        <>
            <NewsModal
                open={open}
                edit={edit}
                title={title}
                color={color}
                editcard={editcard}
                setEditCard={setEditCard}
                setOpen={setOpen}
                handleEdit={handleEdit}
                handleSubmit={handleSubmit}
                handleDelete={handleOnDeleteRow}
            />
            <Col span={24} style={{ paddingTop: '10px' }}>
                <NewTable
                    total={total}
                    extra_columns={extra_columns}
                    set_extra_columns={set_extra_columns}
                    loading={loading}
                    page_name={'NewsList'}
                    force_reload={force_reload}
                    columns={default_column.concat(extra_columns || [])}
                    getData={getData}
                    datas={datas}//table資料
                    add_button_title={'新增貼文'}//新增按鈕上的名稱
                    handleOnAddRow={handleOnAddRow}//新增row 內容
                    rowkey={'blog_id'}//key
                    setSelectedRowKeys={setSelectedRowKeys}
                    selectedRowKeys={selectedRowKeys}
                    handleOnDeleteRow={handleOnDeleteRow}//多筆刪除
                    searchdate={false}
                ></NewTable>
            </Col>
        </>
    );
};

export default AdminNews;